import { render, staticRenderFns } from "./RowSignUpEmail.vue?vue&type=template&id=e970c45a&scoped=true&"
import script from "./RowSignUpEmail.vue?vue&type=script&lang=ts&"
export * from "./RowSignUpEmail.vue?vue&type=script&lang=ts&"
import style0 from "./RowSignUpEmail.vue?vue&type=style&index=0&id=e970c45a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e970c45a",
  null
  
)

export default component.exports